import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card.tsx';
import { useGetUserAPIKeysQuery } from '@/features/user-profile/hooks/queries/get-user-api-keys.tsx';
import { CreateApiKeyDialogButton } from '@/features/user-profile/components/api-keys/create-api-key-dialog-button.tsx';
import { ApiKeysTable } from '@/features/user-profile/components/api-keys/table/api-keys-table.tsx';
import { Link } from 'react-router';
import { ExternalLinkIcon } from '@radix-ui/react-icons';

export const AccountApiKeys = () => {
  const { data: apiKeys, isLoading } = useGetUserAPIKeysQuery();

  return (
    <DashboardCard className="min-h-[265px] border p-4" isLoading={isLoading}>
      <CardHeader className="flex w-full flex-row justify-between p-0">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <CardTitle>API keys</CardTitle>-
            <Link to="/docs/external-api" className="flex items-center gap-0.5 text-sm">
              <ExternalLinkIcon className="size-[16px]" />
              <span>Docs</span>
            </Link>
          </div>
          <CardDescription>
            A list of all API keys for your account. Do not share your API key with others.
          </CardDescription>
        </div>
        <CreateApiKeyDialogButton />
      </CardHeader>
      <CardContent className="p-0">
        <ApiKeysTable apiKeys={apiKeys || []} />
      </CardContent>
    </DashboardCard>
  );
};
